export default "__VITE_ASSET__7QP3$$pQ__"